<template>
    <div class="full-wdith-editor">
        <EditorTitle
            :showReturnBtn="true"
            :returnLabel="returnLabel"
            :titleLabel="i18n.tkey('lang_receive_method_1')"
            :showOperationBtn="true"
            :operationLabel="i18n.tkey('lang_add_receive_manager')"
            @clickReturnBtn="clickReturnBtn"
            @clickOperationBtn="goAddItem"
            tkey="收款方式"
        />
<!--        <div class="editor-title-toolbar">-->
<!--            <ReturnButton-->
<!--                class="return-btn"-->
<!--                @click="clickReturnBtn"-->
<!--                v-show="showReturnBtn !== null && showReturnBtn !== false"-->
<!--                :label="returnLabel"-->
<!--            />-->

<!--            <div>-->
<!--                <h2 tkey="收款方式">{{i18n.tkey("lang_receive_method_1")}}</h2>-->
<!--            </div>-->

<!--            <div class="right-operation-btn">-->
<!--                <el-button type="primary" @click="goAddItem" tkey="添加收款方式">{{i18n.tkey("lang_add_receive_manager")}}</el-button>-->
<!--            </div>-->
<!--        </div>-->

        <PaymentMethodList
            v-if="viewPart === 'list'"
            @clickEdit="goEdit"
        />

        <InsertOrEditPayment
            :obj="editObj"
            v-if="viewPart === 'edit'"
            @editSuccess="clickReturnBtn"
        />
    </div>
</template>

<script setup>

import InsertOrEditPayment from "@/components/shopopee/material/insertOrEditPayment.vue";
import PaymentMethodList from "@/components/shopopee/material/paymentMethodList.vue";
import ReturnButton from "@/components/shopopee/common/returnButton.vue";
import EditorTitle from "@/components/shopopee/common/editorTitle.vue";
import {inject, ref, computed} from "vue";


const props = defineProps(["showReturnBtn"])
const emits = defineEmits(["clickReturnBtn"])

const i18n = inject("i18n")

const viewPart = ref("list")
const editObj = ref(null)

const returnLabel = computed(() => {
    let text = i18n.tkey("lang_return")

    if (viewPart.value === "edit"){
        text = i18n.tkey("lang_return")
    }

    return text

})

function goAddItem(){
    viewPart.value = "edit"
}

function clickReturnBtn(){
    if (viewPart.value === "edit"){
        viewPart.value = "list"
        editObj.value = null
    }else{
        emits("clickReturnBtn")
    }

}

function goEdit(obj){
    viewPart.value = "edit"
    editObj.value = obj
}

function goAdd(){
    viewPart.value = "edit"
    editObj.value = null
}

</script>

<style scoped>
.full-wdith-editor {
    width: 100%;
}

.editor-title-toolbar {
    text-align: center;
    position: relative;
    margin-bottom: 32px;
}

.editor-title-toolbar .return-btn {
    position: absolute;
    left: 0;
    top: 5px;
}

.editor-title-toolbar .right-operation-btn {
    position: absolute;
    right: 0;
    top: 0;
}

</style>